import {useCallback, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../../redux';
import {getProfileNotifications, readNotification} from '../../../../redux/actions/profile';
import {addNotification} from '../../../../redux/actions/snackbar';
import {profileNotificationsSelector} from '../../../../redux/selectors/profile';
import {SnackbarNotificationType} from '../../../../shared/components/snackbar/model';
import {HttpWrapperOptions} from '../../../../shared/httpWrapper';
import {NotificationStatus} from '../../../../shared/models/profile/notification';
import {View} from './view';

export const ReadAllButton = () => {
  const dispatch = useAppDispatch();
  const notificationsSource = useSelector(profileNotificationsSelector());
  const [showError, setShowError] = useState(false);
  const notReadNotifications = useMemo(() => {
    return (notificationsSource || []).filter((n) => n.statusId === NotificationStatus.NotRead);
  }, [notificationsSource]);

  const onClick = useCallback(async () => {
    for (const notification of notReadNotifications) {
      try {
        const httpOptions = new HttpWrapperOptions();
        httpOptions.ExtraTries(5);
        httpOptions.IgnoreDisplayError(true);

        if (!notification?.id) {
          continue;
        }

        await dispatch(await readNotification(notification.id, httpOptions));
      } catch (e) {
        if (!showError) {
          dispatch(
            addNotification({
              type: SnackbarNotificationType.Error,
              message: (e as any)?.message,
            }),
          );
          setShowError(true);
        }
      }
    }
    dispatch(getProfileNotifications());
    setShowError(false);
  }, [notReadNotifications, showError]);

  return View({
    hide: !notReadNotifications.length,
    onClick,
  });
};
